/* eslint-disable no-param-reassign */
import { cloneDeep, map, find } from 'lodash';

import * as connectorOps from '../../../api/Connectors/connector-operations';
import Connectors from '../../../api/Connectors/Connectors';
import * as sourceOps from '../../../api/Sources/source-operations';

import methodPromise from '../../../modules/method-promise-wrapper';

import sourcesExamples from '../fixtures-examples/sources';
import connectorsExamples from '../fixtures-examples/connectors';

const createExampleItems = async userId => {
  try {
    const connectorIds = map(connectorsExamples, exampleConnector =>
      methodPromise('connectors.insert', exampleConnector, userId)
    );
    await Promise.all(connectorIds);

    const userConnectors = Connectors.find({ owner: userId }).fetch();
    const sourcesWithConnectorIds = map(sourcesExamples, sourceExample => {
      const sourcesWidthId = cloneDeep(sourceExample);
      const connectorName = sourceOps.getConnectorId(sourceExample);
      const connector = find(userConnectors, ['name', connectorName]);
      const connectorId = connectorOps.getId(connector);
      sourcesWidthId.connectorId = connectorId;
      return sourcesWidthId;
    });

    const sourceIds = map(sourcesWithConnectorIds, exampleSource =>
      methodPromise('sources.insert', exampleSource, {}, userId)
    );
    await Promise.all(sourceIds);
  } catch (error) {
    throw Error(`Hey You have an error: ${error.message}`, 'danger');
  }
};

export default createExampleItems;
